import React from 'react';
import MediaImage from './MediaImage';

type HeroImageProps = {
  src?: string | null;
  alt: string;
  className?: string;
  /** CSS object-position, e.g. "50% 35%" from focal point */
  position?: string;
  priority?: boolean;
};

/**
 * Hero / cover imagery — cover fill, eager load, optional focal position.
 */
export const HeroImage: React.FC<HeroImageProps> = ({
  src,
  alt,
  className = '',
  position = 'center',
  priority = false,
}) => (
  <MediaImage
    src={src}
    alt={alt}
    fit="cover"
    position={position}
    loading={priority ? 'eager' : 'lazy'}
    fetchPriority={priority ? 'high' : undefined}
    className={`w-full h-full ${className}`}
  />
);

export default HeroImage;
